/* eslint-disable consistent-return */
import { Alert, Col, Layout, Row, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { getSupaClient } from "../../lib/supabase";
import { setOnboardingStatus } from "../Onboarding/Onboarding";

const { Content } = Layout;

const queryString = require("query-string");

const SlackSignedIn = (props) => {
  const supabase = getSupaClient();
  const [loading, setLoading] = useState(true);
  const [slackError, setSlackError] = useState(false);
  const [teamError, setTeamError] = useState(false);
  const [databaseError, setDatabaseError] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const slackCode = queryString.parse(location.search).code;

  const setLocalStorage = (data) => {
    localStorage.setItem("team-id", data.team.id);
    localStorage.setItem("team-name", data.team.name);
    localStorage.setItem("slack-id", data.appUser.slack_id);
  };

  const setIdentifiers = (data) => {
    window.analytics.identify(`${data.team.name}-${data.appUser.slack_id}`);
    window.posthog.identify(`${data.team.name}-${data.appUser.slack_id}`);
    window.posthog.capture("Signed up");
    window.analytics.track("Signed up", {
      slackId: `${data.appUser.slack_id}`,
      teamId: `${data.team.id}`,
    });
    window.analytics.track("Slack team member added", {
      slackId: `${data.appUser.slack_id}`,
      teamId: `${data.team.id}`,
    });
  };

  const handleSlackRedirect = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_API}/signinwithslack/`,
      {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          slackCode,
          reactAppURI: `${process.env.REACT_APP_URI}/auth/signedin/`,
          supaUser: supabase.auth.user(),
        }),
      }
    );
    const { data, error } = await response.json();
    setLoading(false);
    if (error) {
      console.log("error from /signinwithslack", error);
      if (error === "slack_error") setSlackError(true);
      if (error === "team_error") setTeamError(true);
      if (error === "database_error") setDatabaseError(true);
      return;
    } else {
      const user = supabase.auth.user();
      setOnboardingStatus(user?.email, "slack-await-approval");
      window.analytics.track("Sign up - slack await approval");
    }
    setLocalStorage(data);
    await setIdentifiers(data);
    return navigate("/home");
  };

  // load once
  useEffect(() => {
    handleSlackRedirect();
  }, []);

  return (
    <div>
      <Content align="middle" style={{ minHeight: "100vh" }}>
        <Row
          type="flex"
          justify="center"
          align="middle"
          style={{ minHeight: "100vh" }}
        >
          <Col span={12}>
            <div>
              {slackError ? (
                <Alert
                  message="Error from Slack"
                  description="We got an error trying to sign in with Slack. Please contact hello@dots.community."
                  type="error"
                  showIcon
                />
              ) : null}
            </div>
            <div>
              {databaseError ? (
                <Alert
                  message="Database error"
                  description="We experienced an error setting up your account. Please contact hello@dots.community."
                  type="error"
                  showIcon
                />
              ) : null}
            </div>
            <div>
              {teamError ? (
                <Alert
                  message="Team error"
                  description={
                    <div>
                      We couldn&apos;t find your team&apos;s Slack workspace in
                      Dots. Please contact hello@dots.community or reach out
                      through Chat for help, or if you want access!
                    </div>
                  }
                  type="error"
                  showIcon
                />
              ) : null}
            </div>
          </Col>
        </Row>
      </Content>
    </div>
  );
};

export default SlackSignedIn;
